// /////////////////////////////
// Shipping Restriction Codes //
// /////////////////////////////

export default {
  105: 105,
  106: 106,
  110: 110,
}
